import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/flights/airports.ts
import { Exception } from "@wbk/logger";
var getAirports = (_0) => __async(void 0, [_0], function* ({ search, lang }) {
  try {
    const params = { lang };
    if (search)
      params.search = search;
    const data = yield fetchClient({
      url: `/flights/airports?${new URLSearchParams(params).toString()}`,
      version: "v1"
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getAirportsException"
    });
  }
});
var getPopularAirports = (_0) => __async(void 0, [_0], function* ({ lang }) {
  try {
    const data = yield fetchClient({
      url: `/flights/airports/popular?lang=${lang}`,
      version: "v1"
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getPopularAirportsException"
    });
  }
});

export {
  getAirports,
  getPopularAirports
};
//# sourceMappingURL=chunk-ZQP2RVBN.mjs.map